import React, { useState, useEffect, useRef } from "react";
import {
  AppBar, Toolbar, Button, Box, ToggleButton, ToggleButtonGroup,
  Typography, styled, Avatar, IconButton, Drawer, List, ListItem,
  ListItemButton, ListItemText, Divider, useMediaQuery, useTheme,
  Popper, Paper, Grow, ClickAwayListener, MenuList, Menu,
  MenuItem,
  ListItemIcon,
  Collapse,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import ayujalogo from "../Logos/Ayuja_Logo.jpg";
import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from "../../fetchSetup";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import LocalLaundryServiceOutlinedIcon from "@mui/icons-material/LocalLaundryServiceOutlined";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../Common/LanguageSwitcher";
import axios from "axios";

// ─── SERVICES SUBMENU OPTIONS ─────────────────────────────────────────────────
// labelKey/descKey point into the "header" i18n namespace — same pattern as doc 5
const SERVICE_CONFIG = {
  medicines: {
    labelKey: "Medicines",
    descKey: "medicinesDesc",
    path: "/medicine-order-type",
    icon: <MedicationOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#006D77",
    bg: "#E0F7FA",
  },

  diagnostic: {
    labelKey: "Diagnostics",
    descKey: "diagnosticsDesc",
    path: "/medicine-diagnostic",
    icon: <BiotechOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#7B1FA2",
    bg: "#F3E5F5",
  },

  nursing: {
    labelKey: "Nursing Physio",
    descKey: "nursingPhysioDesc",
    path: "/NursingPhysioBooking",
    icon: <LocalHospitalOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#004369",
    bg: "#E0F2F1",
  },

  physiotherapy: {
    labelKey: "Packages",
    descKey: "healthPackagesDesc",
    path: "/services?section=packages",
    icon: <Inventory2OutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#9a1b94",
    bg: "#F3E5F5",
  },
  healthCamp:{
     labelKey: "Health Camps",
    descKey: "healthCampsDesc",
    path: "/services?section=camps",
    icon: <HolidayVillageOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#9a981b",
    bg: "#F3E5F5",
  }
};
// ─── ORDER SUBMENU OPTIONS ─────────────────────────────────────────────────────
const orderSubLinks = [
  {
    labelKey: "medicineOrders",
    descKey: "medicineOrdersDesc",
    path: "/my-orders",
    icon: <MedicationOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#006D77",
    bg: "#E0F7FA",
  },
  {
    labelKey: "diagnosticOrders",
    descKey: "diagnosticOrdersDesc",
    path: "/my-bookings",
    icon: <BiotechOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#7B1FA2",
    bg: "#F3E5F5",
  },
  {
    labelKey: "bookedPackages",
    descKey: "bookedPackagesDesc",
    path: "/my-packagebookings",
    icon: <CardMembershipOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#E65100",
    bg: "#FFF3E0",
  },
  {
    labelKey: "Nursing Physio",
    descKey: "nursingPhysioDesc",
    path: "/my-NursingPhyservices",
    icon: <LocalHospitalOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#6A1B9A",
    bg: "#F3E5F5",
  },
];

// ─── SUPPORT SUBMENU OPTIONS ──────────────────────────────────────────────────
const supportSubLinks = [
  {
    labelKey: "Complaints",
    descKey: "complaintsDesc",
    path: "/my-complaints",
    icon: <ReportProblemOutlinedIcon sx={{ fontSize: 18 }} />,
    color: "#C62828",
    bg: "#FFEBEE",
  },
  {
    labelKey: "Feedback",
    descKey: "feedbackDesc",
    path: "/my-Feedback",
    icon: <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />,
    color: "#1565C0",
    bg: "#E3F2FD",
  },
];

// Public nav links
const publicNavLinks = [
  { labelKey: "Home", path: "/" },
  { labelKey: "Services", path: "/serviceweprovide" },
  { labelKey: "AboutUs", path: "/aboutus" },
  { labelKey: "Packages", path: "/packages" },
  { labelKey: "ContactUs", path: "/contactus" },
];

// Base logged-in links (non-Orders)
const baseUserLinks = [
  { labelKey: "Home", path: "/services" },
];

// Other resident links
const extraResidentLinks = [
  { labelKey: "SubscriptionPlans", path: "/subscription-management" },
];

// ─── SERVICES DROPDOWN (Desktop) ──────────────────────────────────────────────
function ServicesDropdown({ navFontSize, navPx, isActive, navigate, location }) {
  const { t } = useTranslation("header");
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isServicesActive = {}

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        endIcon={
          open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 16, ml: -0.5 }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
        }
        sx={{
          textTransform: "none",
          color: isServicesActive || open ? "#006D77" : "#121212",
          fontWeight: "bold",
          borderBottom: isServicesActive || open ? "2px solid #006D77" : "2px solid transparent",
          borderRadius: 0,
          fontSize: navFontSize,
          whiteSpace: "nowrap",
          minWidth: "auto",
          px: navPx,
          gap: 0.2,
          transition: "all 0.18s",
          "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
        }}
      >
        <HealthAndSafetyOutlinedIcon sx={{ fontSize: 17, mr: 0.4, mb: 0.2 }} />
        {t("services")}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal={false}
        style={{ zIndex: 13001 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={180} style={{ transformOrigin: "top left" }}>
            <Paper
              elevation={0}
              sx={{
                mt: 1.5,
                borderRadius: "14px",
                border: "1px solid #E8F0F0",
                boxShadow: "0 8px 32px rgba(0,109,119,0.13), 0 2px 8px rgba(0,0,0,0.06)",
                overflow: "hidden",
                minWidth: 290,
              }}
            >
              <Box sx={{ px: 2.5, py: 1.5, background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)" }}>
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                  {t("services")}
                </Typography>
              </Box>

             
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

// ─── ORDERS DROPDOWN (Desktop) ────────────────────────────────────────────────
function OrdersDropdown({ navFontSize, navPx, isActive, navigate, location }) {
  const { t } = useTranslation("header");
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isOrderActive = orderSubLinks.some((l) => isActive(l.path));

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        endIcon={
          open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 16, ml: -0.5 }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
        }
        sx={{
          textTransform: "none",
          color: isOrderActive || open ? "#006D77" : "#121212",
          fontWeight: "bold",
          borderBottom: isOrderActive || open ? "2px solid #006D77" : "2px solid transparent",
          borderRadius: 0,
          fontSize: navFontSize,
          whiteSpace: "nowrap",
          minWidth: "auto",
          px: navPx,
          gap: 0.2,
          transition: "all 0.18s",
          "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
        }}
      >
        <ShoppingBagOutlinedIcon sx={{ fontSize: 17, mr: 0.4, mb: 0.2 }} />
        {t("orders")}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal={false}
        style={{ zIndex: 13001 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={180} style={{ transformOrigin: "top left" }}>
            <Paper
              elevation={0}
              sx={{
                mt: 1.5,
                borderRadius: "14px",
                border: "1px solid #E8F0F0",
                boxShadow: "0 8px 32px rgba(0,109,119,0.13), 0 2px 8px rgba(0,0,0,0.06)",
                overflow: "hidden",
                minWidth: 280,
              }}
            >
              <Box sx={{ px: 2.5, py: 1.5, background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)" }}>
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                  {t("orders")}
                </Typography>
              </Box>

              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList sx={{ p: 1 }}>
                  {orderSubLinks.map((item) => (
                    <MenuItem
                      key={item.path}
                      onClick={() => { navigate(item.path); setOpen(false); }}
                      selected={isActive(item.path)}
                      sx={{
                        borderRadius: "10px",
                        mb: 0.5,
                        px: 1.5,
                        py: 1.2,
                        gap: 1.5,
                        alignItems: "flex-start",
                        transition: "all 0.15s",
                        "&:hover": { backgroundColor: item.bg },
                        "&.Mui-selected": { backgroundColor: item.bg + "CC" },
                        "&:last-child": { mb: 0 },
                      }}
                    >
                      <Box sx={{
                        width: 36, height: 36, borderRadius: "10px",
                        backgroundColor: item.bg, color: item.color,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0, mt: 0.2,
                        border: `1.5px solid ${item.color}22`,
                      }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontSize: 13.5, fontWeight: isActive(item.path) ? 700 : 600,
                          color: isActive(item.path) ? item.color : "#1a1a1a",
                          lineHeight: 1.3,
                        }}>
                          {t(item.labelKey)}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888", mt: 0.3, lineHeight: 1.3 }}>
                          {t(item.descKey)}
                        </Typography>
                      </Box>
                      {isActive(item.path) && (
                        <Box sx={{
                          ml: "auto", width: 6, height: 6, borderRadius: "50%",
                          backgroundColor: item.color, mt: 1.5, flexShrink: 0,
                        }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

// ─── SUPPORT DROPDOWN (Desktop) ───────────────────────────────────────────────
function SupportDropdown({ navFontSize, navPx, isActive, navigate, location }) {
  const { t } = useTranslation("header");
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isSupportActive = supportSubLinks.some((l) => isActive(l.path));

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        endIcon={
          open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 16, ml: -0.5 }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
        }
        sx={{
          textTransform: "none",
          color: isSupportActive || open ? "#006D77" : "#121212",
          fontWeight: "bold",
          borderBottom: isSupportActive || open ? "2px solid #006D77" : "2px solid transparent",
          borderRadius: 0,
          fontSize: navFontSize,
          whiteSpace: "nowrap",
          minWidth: "auto",
          px: navPx,
          gap: 0.2,
          transition: "all 0.18s",
          "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
        }}
      >
        <ForumOutlinedIcon sx={{ fontSize: 17, mr: 0.4, mb: 0.2 }} />
        {t("My Requests")}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal={false}
        style={{ zIndex: 13001 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={180} style={{ transformOrigin: "top left" }}>
            <Paper
              elevation={0}
              sx={{
                mt: 1.5,
                borderRadius: "14px",
                border: "1px solid #FDECEA",
                boxShadow: "0 8px 32px rgba(198,40,40,0.10), 0 2px 8px rgba(0,0,0,0.06)",
                overflow: "hidden",
                minWidth: 260,
              }}
            >
              <Box sx={{ px: 2.5, py: 1.5, background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)" }}>
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                  {t("myRequests")}
                </Typography>
              </Box>

              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList sx={{ p: 1 }}>
                  {supportSubLinks.map((item) => (
                    <MenuItem
                      key={item.path}
                      onClick={() => { navigate(item.path); setOpen(false); }}
                      selected={isActive(item.path)}
                      sx={{
                        borderRadius: "10px",
                        mb: 0.5,
                        px: 1.5,
                        py: 1.2,
                        gap: 1.5,
                        alignItems: "flex-start",
                        transition: "all 0.15s",
                        "&:hover": { backgroundColor: item.bg },
                        "&.Mui-selected": { backgroundColor: item.bg + "CC" },
                        "&:last-child": { mb: 0 },
                      }}
                    >
                      <Box sx={{
                        width: 36, height: 36, borderRadius: "10px",
                        backgroundColor: item.bg, color: item.color,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0, mt: 0.2,
                        border: `1.5px solid ${item.color}22`,
                      }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontSize: 13.5, fontWeight: isActive(item.path) ? 700 : 600,
                          color: isActive(item.path) ? item.color : "#1a1a1a",
                          lineHeight: 1.3,
                        }}>
                          {t(item.labelKey)}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888", mt: 0.3, lineHeight: 1.3 }}>
                          {t(item.descKey)}
                        </Typography>
                      </Box>
                      {isActive(item.path) && (
                        <Box sx={{
                          ml: "auto", width: 6, height: 6, borderRadius: "50%",
                          backgroundColor: item.color, mt: 1.5, flexShrink: 0,
                        }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

// ─── MAIN HEADER ──────────────────────────────────────────────────────────────
function Header({ username }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery("(max-width:1300px)");
  const { t } = useTranslation("header");

  const [selected, setSelected] = useState("");
  const [user, setUser] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ordersDrawerOpen, setOrdersDrawerOpen] = useState(false);
  const [supportDrawerOpen, setSupportDrawerOpen] = useState(false);
  const [servicesDrawerOpen, setServicesDrawerOpen] = useState(false);

  const logoutapi = process.env.REACT_APP_LOGOUT_API;
  const width = window.innerWidth;
const API_URL = process.env.REACT_APP_API_BASE_URL;
const [community, setCommunity] = useState("");

const [communityServices, setCommunityServices] = useState([]);
const [selectedCommunity, setSelectedCommunity] = useState(null);
const [loadingCommunityServices, setLoadingCommunityServices] = useState(false);

 
  let navFontSize = 14;
  let navPx = 1.5;
  if (width <= 1100) { navFontSize = 11; navPx = 0.5; }
  else if (width <= 1300) { navFontSize = 12; navPx = 0.8; }
  else if (width <= 1450) { navFontSize = 13; navPx = 1.2; }

  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) { setUser(null); return; }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
        setCommunity(userData.address.community_name)
        console.log(userData.address.community_name)
        try {

      if (!(userData.address.community_name)) {
        setCommunityServices([]);
        return;
      }
      const community_data=userData.address.community_name
      const response = await axios.get(
        `${API_URL}/community/config-services`,
        {
      params: {
        community_name: community_data
      }
    }
      );
      sessionStorage.setItem("community",userData.address.community_name)
      sessionStorage.setItem("communityServices",response.data.services)
      setCommunityServices(
        response.data.services || []
      );

    } catch (error) {

      console.error(
        "Error fetching community services:",
        error
      );

      setCommunityServices([]);

    }
      } catch { setUser(null); }
    };
    fetchUser();
  }, [location, username]);
  

 const serviceSubLinks = communityServices
  .map((serviceKey) => {
    const service = SERVICE_CONFIG[serviceKey];

    if (!service) {
      return null;
    }

    return {
      key: serviceKey,
      ...service,
    };
  })
  .filter(Boolean);


  const isActive = (path) => {
  const [pathname, query] = path.split("?");

  if (location.pathname !== pathname) return false;

  // No query params in the menu item
  if (!query) return location.search === "";

  const currentParams = new URLSearchParams(location.search);
  const targetParams = new URLSearchParams(query);

  for (const [key, value] of targetParams.entries()) {
    if (currentParams.get(key) !== value) {
      return false;
    }
  }

  return true;
};
  const isOrderActive = orderSubLinks.some((l) => isActive(l.path));

  const confirmLogout = () => { setDialogOpen(true); setDrawerOpen(false); };
  const isSupportActive = supportSubLinks.some((l) => isActive(l.path));
  const handleLogout = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      await apiRequest(`${logoutapi}/${userId}`, { method: "POST" });
    } catch {}
    sessionStorage.clear();
    setUser(null);
    navigate("/Login");
  };
  const [profileMenuAnchor, setProfileMenuAnchor] = React.useState(null);

  const profileMenuOpen = Boolean(profileMenuAnchor);

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor((prev) =>
      prev ? null : event.currentTarget
    );
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const navBtnSx = (path) => ({
    textTransform: "none",
    color: isActive(path) ? "#006D77" : "#121212",
    fontWeight: isActive(path) ? "bold" : "bold",
    borderBottom: isActive(path) ? "2px solid #006D77" : "2px solid transparent",
    borderRadius: 0,
    fontSize: navFontSize,
    whiteSpace: "nowrap",
    minWidth: "auto",
    px: navPx,
    transition: "all 0.18s",
    "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
  });

  // ─── Drawer (mobile) ──────────────────────────────────────────────────────
  const renderDrawer = () => (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      PaperProps={{
        sx: {
          width: 280,
          backgroundColor: "#f9fafb",
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
        },
      }}
    >
      {/* Drawer header */}
      <Box sx={{
        background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)",
        px: 2.5, pt: 3, pb: 2.5,
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        {user ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              alt={user.name}
              src={user.avatarUrl || ""}
              sx={{ width: 42, height: 42, bgcolor: "rgba(255,255,255,0.25)", fontWeight: "bold", fontSize: 18, border: "2px solid rgba(255,255,255,0.5)" }}
            >
              {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
            </Avatar>
            <Box>
              <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}>{user.name}</Typography>
              <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.7)", textTransform: "capitalize" }}>
                {user.role}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 16 }}>{t("menu")}</Typography>
        )}
        <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Language switcher — visible in the drawer for mobile users */}
      <Box sx={{ px: 2, pt: 1.5 }}>
        <LanguageSwitcher size="small" />
      </Box>

      <List sx={{ pt: 1, pb: 2 }}>
        {/* Public links */}
        {!user && publicNavLinks.map((link) => (
          <ListItem key={link.path} disablePadding>
            <ListItemButton
              onClick={() => { navigate(link.path); setDrawerOpen(false); }}
              selected={isActive(link.path)}
              sx={{
                mx: 1, borderRadius: 2, mb: 0.5,
                "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
              }}
            >
              <ListItemText
                primary={t(link.labelKey)}
                primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        ))}

        {/* Logged-in: base links */}
        {user && baseUserLinks.map((link) => (
          <ListItem key={link.path} disablePadding>
            <ListItemButton
              onClick={() => { navigate(link.path); setDrawerOpen(false); }}
              selected={isActive(link.path)}
              sx={{
                mx: 1, borderRadius: 2, mb: 0.5,
                "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
              }}
            >
              <ListItemText
                primary={t(link.labelKey)}
                primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        ))}

        {/* SERVICES + ORDERS + SUPPORT accordions — resident only */}
        {user?.role === "resident" && (
          <>
            {/* ── SERVICES accordion ── */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setServicesDrawerOpen((v) => !v)}
                sx={{
                  mx: 1, borderRadius: 2, mb: 0.5,
                  backgroundColor: serviceSubLinks.some((l) => isActive(l.path)) ? "#E0F7FA" : servicesDrawerOpen ? "#F0FFFE" : "transparent",
                  "&:hover": { backgroundColor: "#E0F7FA" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                  <HealthAndSafetyOutlinedIcon sx={{ fontSize: 18, color: serviceSubLinks.some((l) => isActive(l.path)) || servicesDrawerOpen ? "#006D77" : "#555" }} />
                  <ListItemText
                    primary={t("services")}
                    primaryTypographyProps={{
                      fontWeight: 700, fontSize: 14,
                      color: serviceSubLinks.some((l) => isActive(l.path)) || servicesDrawerOpen ? "#006D77" : "#1a1a1a",
                    }}
                  />
                </Box>
                {servicesDrawerOpen
                  ? <KeyboardArrowUpIcon sx={{ color: "#006D77", fontSize: 18 }} />
                  : <KeyboardArrowDownIcon sx={{ color: "#888", fontSize: 18 }} />
                }
              </ListItemButton>
            </ListItem>

            <Collapse in={servicesDrawerOpen} timeout={200}>
              <Box sx={{ mx: 1, mb: 0.5 }}>
                {serviceSubLinks.map((item) => (
                  <ListItemButton
                    key={item.path}
                    onClick={() => { navigate(item.path); setDrawerOpen(false); setServicesDrawerOpen(false); }}
                    selected={isActive(item.path)}
                    sx={{
                      borderRadius: "10px", mb: 0.5, pl: 2,
                      "&.Mui-selected": { backgroundColor: item.bg },
                      "&:hover": { backgroundColor: item.bg },
                    }}
                  >
                    <Box sx={{
                      width: 30, height: 30, borderRadius: "8px", mr: 1.5, flexShrink: 0,
                      backgroundColor: item.bg, color: item.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 16 } })}
                    </Box>
                    <ListItemText
                      primary={t(item.labelKey)}
                      secondary={t(item.descKey)}
                      primaryTypographyProps={{
                        fontWeight: isActive(item.path) ? 700 : 600, fontSize: 13,
                        color: isActive(item.path) ? item.color : "#1a1a1a",
                      }}
                      secondaryTypographyProps={{ fontSize: 10.5, color: "#999" }}
                    />
                    {isActive(item.path) && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: item.color, flexShrink: 0 }} />
                    )}
                  </ListItemButton>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ mx: 2, my: 1, borderColor: "#EEE" }} />

            {/* ── ORDERS accordion ── */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setOrdersDrawerOpen((v) => !v)}
                sx={{
                  mx: 1, borderRadius: 2, mb: 0.5,
                  backgroundColor: isOrderActive ? "#E0F7FA" : ordersDrawerOpen ? "#F0FFFE" : "transparent",
                  "&:hover": { backgroundColor: "#E0F7FA" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                  <ShoppingBagOutlinedIcon sx={{ fontSize: 18, color: isOrderActive || ordersDrawerOpen ? "#006D77" : "#555" }} />
                  <ListItemText
                    primary={t("orders")}
                    primaryTypographyProps={{
                      fontWeight: 700, fontSize: 14,
                      color: isOrderActive || ordersDrawerOpen ? "#006D77" : "#1a1a1a",
                    }}
                  />
                </Box>
                {ordersDrawerOpen
                  ? <KeyboardArrowUpIcon sx={{ color: "#006D77", fontSize: 18 }} />
                  : <KeyboardArrowDownIcon sx={{ color: "#888", fontSize: 18 }} />
                }
              </ListItemButton>
            </ListItem>

            <Collapse in={ordersDrawerOpen} timeout={200}>
              <Box sx={{ mx: 1, mb: 0.5 }}>
                {orderSubLinks.map((item) => (
                  <ListItemButton
                    key={item.path}
                    onClick={() => { navigate(item.path); setDrawerOpen(false); setOrdersDrawerOpen(false); }}
                    selected={isActive(item.path)}
                    sx={{
                      borderRadius: "10px", mb: 0.5, pl: 2,
                      "&.Mui-selected": { backgroundColor: item.bg },
                      "&:hover": { backgroundColor: item.bg },
                    }}
                  >
                    <Box sx={{
                      width: 30, height: 30, borderRadius: "8px", mr: 1.5, flexShrink: 0,
                      backgroundColor: item.bg, color: item.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 16 } })}
                    </Box>
                    <ListItemText
                      primary={t(item.labelKey)}
                      secondary={t(item.descKey)}
                      primaryTypographyProps={{
                        fontWeight: isActive(item.path) ? 700 : 600, fontSize: 13,
                        color: isActive(item.path) ? item.color : "#1a1a1a",
                      }}
                      secondaryTypographyProps={{ fontSize: 10.5, color: "#999" }}
                    />
                    {isActive(item.path) && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: item.color, flexShrink: 0 }} />
                    )}
                  </ListItemButton>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ mx: 2, my: 1, borderColor: "#EEE" }} />

            {/* ── SUPPORT accordion ── */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setSupportDrawerOpen((v) => !v)}
                sx={{
                  mx: 1, borderRadius: 2, mb: 0.5,
                  backgroundColor: isSupportActive ? "#FFEBEE" : supportDrawerOpen ? "#FFF5F5" : "transparent",
                  "&:hover": { backgroundColor: "#FFEBEE" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                  <ForumOutlinedIcon sx={{ fontSize: 18, color: isSupportActive || supportDrawerOpen ? "#C62828" : "#555" }} />
                  <ListItemText
                    primary={`${t("complaints")} & ${t("feedback")}`}
                    primaryTypographyProps={{
                      fontWeight: 700, fontSize: 14,
                      color: isSupportActive || supportDrawerOpen ? "#C62828" : "#1a1a1a",
                    }}
                  />
                </Box>
                {supportDrawerOpen
                  ? <KeyboardArrowUpIcon sx={{ color: "#C62828", fontSize: 18 }} />
                  : <KeyboardArrowDownIcon sx={{ color: "#888", fontSize: 18 }} />
                }
              </ListItemButton>
            </ListItem>

            <Collapse in={supportDrawerOpen} timeout={200}>
              <Box sx={{ mx: 1, mb: 0.5 }}>
                {supportSubLinks.map((item) => (
                  <ListItemButton
                    key={item.path}
                    onClick={() => { navigate(item.path); setDrawerOpen(false); setSupportDrawerOpen(false); }}
                    selected={isActive(item.path)}
                    sx={{
                      borderRadius: "10px", mb: 0.5, pl: 2,
                      "&.Mui-selected": { backgroundColor: item.bg },
                      "&:hover": { backgroundColor: item.bg },
                    }}
                  >
                    <Box sx={{
                      width: 30, height: 30, borderRadius: "8px", mr: 1.5, flexShrink: 0,
                      backgroundColor: item.bg, color: item.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 16 } })}
                    </Box>
                    <ListItemText
                      primary={t(item.labelKey)}
                      secondary={t(item.descKey)}
                      primaryTypographyProps={{
                        fontWeight: isActive(item.path) ? 700 : 600, fontSize: 13,
                        color: isActive(item.path) ? item.color : "#1a1a1a",
                      }}
                      secondaryTypographyProps={{ fontSize: 10.5, color: "#999" }}
                    />
                    {isActive(item.path) && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: item.color, flexShrink: 0 }} />
                    )}
                  </ListItemButton>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ mx: 2, my: 1, borderColor: "#EEE" }} />

            {extraResidentLinks.map((link) => (
              <ListItem key={link.path} disablePadding>
                <ListItemButton
                  onClick={() => { navigate(link.path); setDrawerOpen(false); }}
                  selected={isActive(link.path)}
                  sx={{
                    mx: 1, borderRadius: 2, mb: 0.5,
                    "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
                  }}
                >
                  <ListItemText
                    primary={t(link.labelKey)}
                    primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </>
        )}

        {/* Login / Register (guest) */}
        {!user && (
          <>
            <Divider sx={{ mx: 2, my: 1 }} />
            {[{ labelKey: "login", path: "/Login" }, { labelKey: "register", path: "/Register" }].map((l) => (
              <ListItem key={l.path} disablePadding>
                <ListItemButton onClick={() => { navigate(l.path); setDrawerOpen(false); }} sx={{ mx: 1, borderRadius: 2 }}>
                  <ListItemText primary={t(l.labelKey)} primaryTypographyProps={{ fontWeight: 700, fontSize: 14 }} />
                </ListItemButton>
              </ListItem>
            ))}
          </>
        )}
      </List>
    </Drawer>
  );

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#fff", color: "#153f4b", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", zIndex: 13000 }}>
      <Toolbar sx={{ flexDirection: "column", padding: "0!important" }}>

        {/* ── NOT LOGGED IN ─────────────────────────────────────────────── */}
        {!user && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", px: { xs: 2, sm: 3, md: 4, lg: 6 }, py: 1,gap:1}}>
            <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
              <img src={ayujalogo} alt="Ayuja Logo" style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48, marginRight: 10 }} />
            </Box>
            {!isMobile && (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: isTablet ? 1 : 3, flexGrow: 1 }}>
                {publicNavLinks.map((link) => (
                  <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
                    {t(link.labelKey)}
                  </Button>
                ))}
              </Box>
            )}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
                <LanguageSwitcher size="small" />
                <ToggleButtonGroup value={selected} exclusive onChange={(_, v) => v && setSelected(v)}
                  sx={{ width: isTablet ? "130px" : "150px", height: "35px", borderRadius: "30px", overflow: "hidden", border: "1px solid teal" }}>
                  <ToggleButton value="login" onClick={() => navigate("/Login")}
                    sx={{ textTransform: "none", fontWeight: "bold", fontSize: isTablet ? "12px" : "14px", px: isTablet ? 1.5 : 2, "&.Mui-selected": { background: "linear-gradient(to right, seagreen, #22577A)", color: "white" } }}>
                    {t("login")}
                  </ToggleButton>
                  <ToggleButton value="register" onClick={() => navigate("/Register")}
                    sx={{ textTransform: "none", fontWeight: "bold", fontSize: isTablet ? "12px" : "14px", "&.Mui-selected": { background: "linear-gradient(to right, seagreen, #22577A)", color: "white" } }}>
                    {t("register")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            )}
            {isMobile && (
              <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "#153f4b" }}>
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        )}

        {/* ── LOGGED IN ─────────────────────────────────────────────────── */}
        {user && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "white", px: { xs: 2, sm: 3, md: 4, lg: 6 }, py: 1, gap: 1 }}>
            {/* Logo */}
            <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
              <img src={ayujalogo} alt="Ayuja Logo" style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48 , marginRight: 10}} />
            </Box>

            {/* Desktop nav */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: isTablet ? 0.5 : 1.5, flexGrow: 1, justifyContent: "center", overflow: "visible" }}>
                {/* Base links */}
                {baseUserLinks.map((link) => (
                  <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
                    {t(link.labelKey)}
                  </Button>
                ))}

                {/* Services links — resident only */}
                {user.role === "resident" && (
                  serviceSubLinks.map((item) => (
                    <Button
                      key={item.path}
                      onClick={() => navigate(item.path)}
                      startIcon={item.icon}
                      sx={{
                        textTransform: "none",
                        color: isActive(item.path) ? "#006D77" : "#121212",
                        fontWeight: "bold",
                        borderBottom: isActive(item.path)
                          ? "2px solid #006D77"
                          : "2px solid transparent",
                        borderRadius: 0,
                        fontSize: navFontSize,
                        whiteSpace: "nowrap",
                        minWidth: "auto",
                        px: navPx,
                        transition: "all 0.18s",
                      "& .MuiButton-startIcon": {
                        color: isActive(item.path) ? item.color : "#121212",
                      },

                        "&:hover": {
                          color: "#006D77",
                          backgroundColor: "transparent",
                          borderBottom: "2px solid #006D77",
                        },
                      }}
                    >
                      {t(item.labelKey)}
                    </Button>
                  ))
                )}

                

               

                {/* <Button
                  onClick={confirmLogout}
                  sx={{
                    textTransform: "none",
                    color: "#D32F2F",
                    fontWeight: 600,
                    fontSize: navFontSize,
                    px: navPx,
                    "&:hover": { backgroundColor: "#fdecea" },
                  }}
                >
                  {t("logout")}
                </Button> */}
              </Box>
            )}
            {/* Right Section */}
            <Box
              sx={{
                ml: "auto",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {isMobile && (
                <IconButton
                  onClick={() => setDrawerOpen(true)}
                  sx={{ color: "#153f4b" }}
                >
                  <MenuIcon />
                </IconButton>
              )}
              {/* Language switcher — resident desktop nav */}
                <LanguageSwitcher size="small" />
              <Box
                onClick={handleProfileMenuOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                  borderRadius: 10,
                  px: 1,
                  py: 0.5,
                  transition: ".2s",

                  "&:hover": {
                    background: "#f5f5f5",
                  },
                }}
              >
                {!isMobile && (
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#222",
                    }}
                  >
                    {user.name}
                  </Typography>
                )}

                <Avatar
                  alt={user.name}
                  src={user.avatarUrl || ""}
                  sx={{
                    width: 38,
                    height: 38,
                    bgcolor: "#007a85",
                  }}
                >
                  {!user.avatarUrl &&
                    user.name?.charAt(0).toUpperCase()}
                </Avatar>

                {!isMobile && <KeyboardArrowDownIcon fontSize="small" />}
              </Box>
            </Box>
            <Menu
              anchorEl={profileMenuAnchor}
              open={profileMenuOpen}
              onClose={handleProfileMenuClose}
              keepMounted
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 8,
                sx: {
                  zIndex: 10000,
                  mt: 1,
                  width: 280,
                  borderRadius: 3,
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate("/profile-dashboard");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      bgcolor: "#007a85",
                    }}
                  >
                    {user.name?.charAt(0)}
                  </Avatar>
                </ListItemIcon>

                <ListItemText
                  primary={user.name}
                  secondary={user.email}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
                <Box sx={{ ml: "auto", display: "flex", alignItems: "center", color: "#64748b" }}>
                  <KeyboardArrowRightIcon sx={{ fontSize: 16 }} />
                </Box>
              </MenuItem>

              <Divider />
              <MenuItem
                onClick={() => {
                  navigate("/profile-details");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <PeopleOutlineOutlinedIcon sx={{ color: "#006D77" }} />
                </ListItemIcon>
                <ListItemText primary={t("Profile")} />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/all-orders");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <ShoppingBagOutlinedIcon color="info" />
                </ListItemIcon>
                <ListItemText primary={t("My Orders")} />
              </MenuItem>
                <MenuItem
                onClick={() => {
                  navigate("/my-packagebookings");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <ShoppingBagOutlinedIcon color="info" />
                </ListItemIcon>
                <ListItemText primary={t("Package Bookings")} />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/diagnostic-reports");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <DescriptionOutlinedIcon color="secondary" />
                </ListItemIcon>
                <ListItemText primary={t("Diagnostic Reports")} />
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/mydoctor-appointments");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <EventAvailableOutlinedIcon color="secondary" />
                </ListItemIcon>
                <ListItemText primary={t("Doctor Appointments")} />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/my-laundry-bookings");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <LocalLaundryServiceOutlinedIcon color="secondary" />
                </ListItemIcon>
                <ListItemText primary={t("Laundry Bookings")} />
              </MenuItem>

              
              <MenuItem
                onClick={() => {
                  navigate("/prescriptions");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <MedicalServicesOutlinedIcon color="success" />
                </ListItemIcon>
                <ListItemText primary={t("Prescriptions")} />
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/referrals");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <WorkspacePremiumOutlinedIcon color="warning" />
                </ListItemIcon>
                <ListItemText primary={t("Reward Points")} />
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/my-complaints");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <ReportProblemOutlinedIcon color="error" />
                </ListItemIcon>
                <ListItemText primary={t("Complaints")} />
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/my-Feedback");
                  handleProfileMenuClose();
                }}
              >
                <ListItemIcon>
                  <FeedbackOutlinedIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={t("Feedback")} />
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => {
                  handleProfileMenuClose();
                  confirmLogout();
                }}
                sx={{ color: "error.main" }}
              >
                <ListItemIcon>
                  <LogoutOutlinedIcon color="error" />
                </ListItemIcon>

                <ListItemText primary={t("Logout")} />
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>

      {renderDrawer()}

      <CustomDialog
        open={dialogOpen}
        title={t("confirmLogoutTitle")}
        message={t("confirmLogoutMessage")}
        onClose={() => setDialogOpen(false)}
        buttonText={t("yes", { ns: "common" })}
        secondaryButtonText={t("cancel", { ns: "common" })}
        onPrimaryAction={() => { setDialogOpen(false); handleLogout(); }}
        onSecondaryAction={() => setDialogOpen(false)}
        type="warning"
      />
    </AppBar>
  );
}

export default Header;